export default function lockBody (condition: any, lockCallback = () => undefined, unlockCallback = () => undefined) {
  const fixedBodyClass = 'g-body-fixed'

  if (condition) {
    if (typeof window !== 'undefined') {
      document.body.classList.toggle(fixedBodyClass, true)

      lockCallback()
    }
  }
  else if (typeof window !== 'undefined') {
    document.body.classList.toggle(fixedBodyClass, false)

    unlockCallback()
  }
}
